import React from "react";
import { TextField, FormControl, InputAdornment } from "@mui/material";
import { facebookTextFieldStyles } from "../../../styles/textFieldStyles";
import { INDIAN_RUPEE_SIGN } from "../../../constant/constant";

const AmountInput = ({
  id,
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  helperText,
  options = {},
}) => {
  return (
    <FormControl
      fullWidth
      required={required}
      error={!!helperText}
      sx={{ mb: { xs: 1.5, sm: 2, md: 2.5 } }}
    >
      <TextField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        helperText={helperText}
        type="text"
        fullWidth
        InputProps={{
          notched: false,
          startAdornment: (
            <InputAdornment position="start" sx={{ mt: "14px", mr: 1, color: "#1C1E21" }}>
              {INDIAN_RUPEE_SIGN}
            </InputAdornment>
          ),
          ...options.InputProps
        }}
        sx={facebookTextFieldStyles}
        {...options}
      />
    </FormControl>
  );
};

export default AmountInput;